import { useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

function getStored() {
    try {
        return localStorage.getItem("os_cookie_consent");
    } catch {
        return null;
    }
}

export default function CookieConsent() {
    const [choice, setChoice] = useState(getStored);

    if (choice) return null;

    const decide = (value) => {
        try {
            localStorage.setItem("os_cookie_consent", value);
        } catch {}
        setChoice(value);
        if (value === "all") {
            window.__loadGA?.();
            window.posthog?.opt_in_capturing?.();
        } else {
            window.posthog?.opt_out_capturing?.();
        }
    };

    return (
        <div
            data-testid="cookie-banner"
            className="fixed bottom-4 inset-x-4 sm:left-6 sm:right-auto sm:max-w-md z-[60] bg-[#0d3d2e] text-[#fcfbf8] rounded-2xl shadow-2xl shadow-black/30 border border-[#fcfbf8]/10 p-5 sm:p-6"
        >
            <div className="flex items-start gap-3 mb-3">
                <div className="h-9 w-9 rounded-full bg-[#d4af37]/20 flex items-center justify-center flex-shrink-0">
                    <Cookie className="h-4.5 w-4.5 text-[#d4af37]" style={{ height: 18, width: 18 }} strokeWidth={1.75} />
                </div>
                <div>
                    <div className="font-semibold text-sm mb-1">Respectăm confidențialitatea ta</div>
                    <p className="text-xs leading-relaxed text-[#fcfbf8]/75">
                        Folosim cookie-uri strict necesare pentru funcționarea site-ului și, doar cu
                        acordul tău, cookie-uri de analiză (Google Analytics) pentru a îmbunătăți
                        experiența. Detalii în{" "}
                        <Link to="/politica-cookies" className="underline text-[#d4af37]" data-testid="cookie-banner-policy-link">
                            Politica Cookie
                        </Link>
                        .
                    </p>
                </div>
            </div>
            <div className="flex gap-2">
                <button
                    onClick={() => decide("all")}
                    data-testid="cookie-accept-all"
                    className="flex-1 rounded-full bg-[#d4af37] text-[#1a1a1a] px-4 py-2.5 text-sm font-semibold hover:bg-[#e0bd49] transition-colors"
                >
                    Accept toate
                </button>
                <button
                    onClick={() => decide("necessary")}
                    data-testid="cookie-necessary-only"
                    className="flex-1 rounded-full border border-[#fcfbf8]/30 text-[#fcfbf8] px-4 py-2.5 text-sm font-medium hover:bg-[#fcfbf8]/10 transition-colors"
                >
                    Doar necesare
                </button>
            </div>
        </div>
    );
}
